package com.milta.feature.settings.presentation

sealed interface WebSettingsIntent {
    data object Load : WebSettingsIntent

    /** Applies immediately (no separate confirm step, unlike mobile's ProfileScreen language dialog —
     * see mockup's dropdown, section 10 of MIL-53). */
    data class SelectLanguage(val tag: String) : WebSettingsIntent

    data class UpdateDeleteConfirmationInput(val value: String) : WebSettingsIntent

    /** Opens the final confirmation dialog — only reachable once the typed name matches exactly
     * (button stays disabled otherwise, enforced in the screen). */
    data object OpenDeleteDialog : WebSettingsIntent
    data object DismissDeleteDialog : WebSettingsIntent
    data object ConfirmDelete : WebSettingsIntent
}
